import { render, staticRenderFns } from "./WerteIcon.vue?vue&type=template&id=5c432ae8"
import script from "./WerteIcon.vue?vue&type=script&lang=js"
export * from "./WerteIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports